import React, { useState, useEffect, Fragment } from 'react';
import axios from 'axios';
import Page from './components/Page';
import Tools from './components/Tools';
import './App.css';
import userIcon from './icons/user.svg';
import pacIcon from './icons/pac.svg';
import banksList from './icons/banks.svg';

const queryString = require('query-string');
function App() {

  const [hash, setHash] = useState('initial');
  const [oldHash, setOldHash] = useState('');
  const [encryptedIdItem, setEncryptedIdItem] = useState(null);
  const [item, setItem] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let urlHash = window.location.hash;
    let urlHashArray=urlHash.split('#');
    
    if(urlHash){
      setHash(urlHashArray[urlHashArray.length - 1]);
    } else {
      setHash('initial');
    }

    const urlParams = queryString.parse(window.location.search);
    setEncryptedIdItem(urlParams.c);

    //get item
    setLoading(true);
    axios.get(`${process.env.REACT_APP_URI_API_LANDING}/item`, {
      params: { id: urlParams.c, expAfter: 15 }
    })
    .then(function (response) {
      setItem(response.data.item);
      setLoading(false);
    })
    .catch(function (error) {
      console.log("Error:", error.message);
      setError(error.message);
      setLoading(false);
    })
  }, []);


  useEffect(() => {
    if (encryptedIdItem){
      saveInteraction(0,'Ingreso');
    }
  }, [encryptedIdItem]); 


  const goTo=(urlHash)=>{
    setOldHash(hash);
    setHash(urlHash);
    window.location.hash = `#${urlHash}`;
  }

  const saveInteraction = (interactionValue, interactionDesc, additionalData=null)=>{
    const options = {
      url: `${process.env.REACT_APP_URI_API_LANDING}/interaction`,
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        id: encryptedIdItem,
        interactionValue: interactionValue,
        interactionDesc: interactionDesc
      }
    };

    if (additionalData) { //parse additional data from array
      additionalData.forEach((data, index) => {
        let fieldName = `addData${index + 1}`;
        options.data[fieldName]= data;
      });
    }

    axios(options).then(response => {
      if(response.status === 200){
        console.log('Saved interaction');
      }
    });
  }

  return (
    <div className="App">
      <header className="App-header">
        <span className="logo"/>
      </header>

      {item ? (
      <Fragment>
          <Page hash={hash} oldHash={oldHash} id="initial">
            <div className="card">
              <p>Estimado(a) Sr(a) <b>{item.f1}</b>.<br /></p>

              {item.optional === 'PAC_MANTENCION' ? (
                <Fragment>
                  <p>Le recordamos que con fecha <b>{item.f2}</b> vence su cuota de mantención asociada al contrato <b>{item.f3}</b> por un valor de UF <b>{item.f4}</b>.<br /><br />
                  Según Ley 21420 a partir del 01-01-2023 esta cuota de Mantención esta afecta a IVA.<br /><br />
                  Este SMS es sólo informativo ya que el pago de esta cuota está asociado a un convenio de Pago Automático de Cuentas suscrito por usted.</p>
                  <div className="pacPatRibbon"></div>
                </Fragment>
              ) : item.optional === 'PAC_CREDITO' ? (
                  <Fragment>
                    <p>Le recordamos que con fecha <b>{item.f2}</b> vence su cuota de crédito asociada al pagaré <b>{item.f3}</b> por un valor de UF <b>{item.f4}</b>.<br /><br />
                      Este SMS es sólo informativo ya que el pago de esta cuota está asociado a un convenio de Pago Automático de Cuentas suscrito por usted.</p>
                    <div className="pacPatRibbon"></div>
                  </Fragment>
              ) : item.optional === 'MANTENCION_SIN_PAC' ? (
                <Fragment>
                      <p>Le recordamos que con fecha <b>{item.f2}</b> vence su cuota de mantención asociada al contrato <b>{item.f3}</b> por un valor de UF <b>{item.f4}</b>.<br /><br />
                  Según Ley 21420 a partir del 01-01-2023 esta cuota de Mantención esta afecta a IVA.<br /><br />
                  Por su comodidad y seguridad prefiera nuestros medios de pago en línea.</p>
                  <div className="paymentMethods">
                    <a className="btn pagoExpress" target="_blank" href="https://parquedelrecuerdo.cl/tu-portal/" onClick={() => { saveInteraction(1, 'PagoPortalClientes') }}>
                      <img src={userIcon} />
                      <div className="wrapper">
                        <span className="top">Pago Portal Clientes</span>
                        <span className="bottom">www.parquedelrecuerdo.cl</span>
                      </div>
                    </a>
                    <div className="twoButtons">
                          <a className="btn sencillito" target="_blank" href="https://www.sencillito.com" onClick={() => { saveInteraction(2, 'Sencillito') }}></a>
                          <a className="btn servipag" target="_blank" href="https://www.servipag.com" onClick={() => { saveInteraction(3, 'Servipag') }}></a>
                    </div>
                  </div>

                  <div className="activateMethods">
                    <a className="btn pagoExpress" target="_blank" href="https://parquedelrecuerdo.trytoku.com/" onClick={() => { saveInteraction(1, 'PagoPortalClientes') }}>
                      <img src={pacIcon}/>
                      <div className="wrapper">
                        <span className="activateText">Inscriba en línea el pago automático con cargo a la cuenta corriente</span>
                      </div>
                    </a>
                    <a target="_blank" href="https://parquedelrecuerdo.trytoku.com/"><img className="banks" src={banksList}/></a>
                  </div>

                  <p className="skip">Si Ud. ya pagó, por favor omita este mensaje</p>
                </Fragment>
              ) : item.optional === 'CREDITO_SIN_PAC' ? (
                      <Fragment>
                        <p>Le recordamos que con fecha <b>{item.f2}</b> vence su cuota de crédito asociada al pagaré <b>{item.f3}</b> por un valor de UF <b>{item.f4}</b>.<br /><br />
                          Por su comodidad y seguridad prefiera nuestros medios de pago en línea.</p>
                        <div className="paymentMethods">
                          <a className="btn pagoExpress" target="_blank" href="https://parquedelrecuerdo.cl/tu-portal/" onClick={() => { saveInteraction(1, 'PagoPortalClientes') }}>
                            <img src={userIcon}/>
                            <div className="wrapper">
                              <span className="top">Pago Portal Clientes</span>
                              <span className="bottom">www.parquedelrecuerdo.cl</span>
                            </div>
                          </a>
                          <div className="twoButtons">
                            <a className="btn sencillito" target="_blank" href="https://www.sencillito.com" onClick={() => { saveInteraction(2, 'Sencillito') }}></a>
                            <a className="btn servipag" target="_blank" href="https://www.servipag.com" onClick={() => { saveInteraction(3, 'Servipag') }}></a>
                          </div>
                        </div>

                        <div className="activateMethods">
                          <a className="btn pagoExpress" target="_blank" href="https://parquedelrecuerdo.trytoku.com/" onClick={() => { saveInteraction(1, 'PagoPortalClientes') }}>
                            <img src={pacIcon}/>
                            <div className="wrapper">
                              <span className="activateText">Inscriba en línea el pago automático con cargo a la cuenta corriente</span>
                            </div>
                          </a>
                          <a target="_blank" href="https://parquedelrecuerdo.trytoku.com/"><img className="banks" src={banksList}/></a>
                        </div>
                        
                        <p className="skip">Si Ud. ya pagó, por favor omita este mensaje</p>
                      </Fragment>
              ) : null}
              
              <p className="disclaimer">*No responda a este SMS, cualquier duda favor comunicarse a nuestro call center al fono <span className="noWrap">600 626 6000</span></p>
            </div>
            
          </Page>
          <div className="footer"></div>
          
      </Fragment>) : 

        !loading ? (
        <div className="page">
            <h1 className="contrast">Error</h1>
            {error ? (
              <p className="contrast">{error}</p>
            ) : null}
        </div>
        ) : null

      }

    </div>
  );
}

export default App;
